import { render, staticRenderFns } from "./SupSelect.vue?vue&type=template&id=20cdb2d8&scoped=true&"
import script from "./SupSelect.vue?vue&type=script&lang=ts&"
export * from "./SupSelect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cdb2d8",
  null
  
)

export default component.exports